// ----------------------------------------------------------------------
// Main docready function that will load our other modules
// ----------------------------------------------------------------------
// universal doc ready function
(function(funcName, baseObj) {
  // The public function name defaults to window.docReady
  // but you can pass in your own object and own function name and those will be used
  // if you want to put them in a different namespace
  funcName = funcName || "ltr6_docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if ( document.readyState === "complete" ) {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function(callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for ltr6_docReady(fn) must be a function");
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function() {callback(context);}, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({fn: callback, ctx: context});
    }
    // if document already ready to go, schedule the ready function to run
    if (document.readyState === "complete") {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener("DOMContentLoaded", ready, false);
        // backup is window load event
        window.addEventListener("load", ready, false);
      } else {
        // must be IE
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})("ltr6_docReady", window);



console.log(
  '%cDHL Logistics Trend Radar 6.0',
  'color: #d40511; background-color: #FFCC00; padding:5px 10px; font-family: sans-serif; font-weight:bold;'
);
// console.log(
//   '%clocal.logistics-trend-radar.com',
//   'color: #ffffff; background-color: #d40511; padding:5px 10px; font-family: sans-serif; font-weight:bold;'
// );

ltr6_docReady(function() {

  ltr6_module_utilities.init();
  ltr6_module_expandable_section.init();
  ltr6_module_tabs.init();
  ltr6_module_challenges.init();
  ltr6_module_navigation.init();
  ltr6_module_trend_pages.init();
  ltr6_module_share.init();
  ltr6_module_analytics.init();
  ltr6_module_radar.init();
  // ltr6_module_anno.init();
  ltr6_module_content.init();
  ltr6_module_panzoom.init();
  ltr6_module_radar_icon.init();
  ltr6_module_print.init();
  ltr6_module_grid_filters.init();

  
  ltr6_module_djatour.init();

  // // LOAD CHAPTER 1 ON LOAD
  // $(window).on('load', function(){

  // });
  // lazyload
  // https://github.com/tuupola/lazyload
  // https://www.appelsiini.net/projects/lazyload/
  $("img.lazyload").lazyload({
    // effect: "fadeIn",
    // data_attribute:'src'
  });

  // popups, image modal
  $('.ltr6-image-modal').featherlight({
    targetAttr: 'src'
  });

  // popups, factoids modal. ugh.
  $('.ltr6-image-modal-factoid').featherlight({
    beforeOpen: function(e){
      // console.log(e);
      var img = $(e.target);
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      var src = img.attr('data-src');
      var srcset = img.attr('data-srcset');
      // if(srcset.indexOf('images/factoids/portrait')!=-1){
      if(typeof srcset !== 'undefined' && srcset !== false){
        // console.log('srcset',srcset);
        if(vw<480){
          src = src.toString().replace('landscape/','portrait/');
        } else {
          src = src.toString().replace('portrait/','landscape/');
        }
        img.attr('data-src',src);
      }
    },
    targetAttr: 'data-src'
  });

  // prevent the jump-to-top on hash links
  // $('#ltr6-wrapper').on('click', 'a[href="#"]', function(event) {
  //   console.log('link TBC');
  //   event.preventDefault();
  //   event.stopPropagation();
  // });


  // badly done select...
  $('#ltr6-wrapper').on('click', '.ltr6-select .select-control', function(event) {
    event.preventDefault();
    var select = $(this);
    if(select.attr('data-open')=='true') return false;
    select.attr('data-open','true');
    setTimeout(function(){
      $(document).on('click', closeSelect);
    },0);
  });
  $('#ltr6-wrapper').on('click', '.ltr6-select .select-control li', function(event) {
    $(this).parent().find('li.active-option').removeClass('active-option');
    $(this).addClass('active-option');
    var text = $(this).text();
    $(this).parent().parent().find('.select-value').text(text);
    setTimeout(function(){
      closeSelect();
    },0);
  });
  function closeSelect(){
    $(document).off('click', closeSelect);
    // console.log('close');
    var select = $('#ltr6-wrapper .ltr6-select .select-control[data-open="true"]');
    select.attr('data-open','false');
  }



  // opengraph
  // if($('#ltr6-wrapper #ltr6-opengraph').length){
  //   $('#ltr6-wrapper #ltr6-opengraph meta').detach().appendTo($('head'));
  // }




  // ==============================================================
  // Text Search
  // ==============================================================
  var searchTrends = ltr6_module_utilities.debounce(function(e) {
      // console.log(e);

      //clear button press, no e sent, so clear and return
      if (typeof e == "undefined"){
        $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('highlighted');
        $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('disabled');
        return;
      }

      var s = $(e.target).val().toLowerCase();
      if(s=='') {
        $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('highlighted');
        $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('disabled');
        return;
      }
      // $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').hide();
      $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('highlighted');
      $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node').addClass('disabled');

      $.each(trends_data, function(index, val) {
         if(val.title.toLowerCase().indexOf(s)!=-1){
          // $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="'+index+'"]').show();
          $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="'+index+'"]').addClass('highlighted');
          $('#ltr6-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="'+index+'"]').removeClass('disabled');
         }
      });

  }, 200);

  $('#ltr6-wrapper .ltr6-trend-search').on('change, keyup', searchTrends);

  //clear button press
  $("#ltr6-wrapper .ltr6-trend-search").on("search", function() {
    searchTrends();  
  });


  // // overide anchor links to smooth scroll accounting for header
  // $('a[href^="#"]').click(function(e){
  //   var link = $(this).attr('href');
  //   if(link.length>1) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     // var anchor = link.replace('#', '');
  //     // console.log('anchor',anchor);
  //     var pos = $(link).offset();
  //     var posTop = pos.top;
  //     // posTop -= 10;
  //     // if($('#navigation-primary').length) posTop -= $('#navigation-primary').height();
  //     // if($('#navigation-secondary').length) posTop -= $('#navigation-secondary').height();
  //     // if($('#ltr6-navigation').length) posTop -= $('#ltr6-navigation').height();
  //     posTop = posTop - (52 + 56 + 54);
  //     $('html,body').animate({scrollTop: posTop}, 1000);
  //   }
  // });

});
